import { render, staticRenderFns } from "./OliverSalesDashboardTabs.vue?vue&type=template&id=68789057"
import script from "./OliverSalesDashboardTabs.vue?vue&type=script&lang=js"
export * from "./OliverSalesDashboardTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports